import type { ITableRowAction } from "~/types/table";

export default () => {
  const { t } = useI18n();

  const createNewTicket = (package_number: string) => {
    createTicketOpen();

    homeFetch(`tickets/types/${package_number.replace(/^#/, "")}`).then((r) => {
      if (!r.data) return;
      createTicketAdd(r.data, package_number);
    });
  };

  const openNewTicket = () => {
    createTicketOpen();
  };

  const goToTicket = (ticketId: number) => {
    const link = useRouter().resolve({ name: "tickets-id", params: { id: ticketId } })?.href;
    useRouter().push(link);
  };

  const submitTicket = (ticket: object) => {
    return homeFetch(`tickets`, {
      method: "POST",
      body: ticket,
    }).then((r) => {
      const ticketId = r.data.data.id;
      toastAdd({
        text: t("ticket_created_successfully"),
        actions: [
          {
            text: t("go_to_entity", { entity: t("ticket", 1).toLowerCase() }),
            handler: () => goToTicket(ticketId),
          },
        ],
      });
      createTicketClose();
      return { ticketId };
    });
  };

  const { focusEntity, unfocusEntity } = useFocus("tickets");

  const useActions = (): (ITableRowAction | null)[] => {
    const { hasCapability } = useCapabilities();

    return [
      {
        key: "focus",
        label: t("focus_entity"),
        handler: (item: object) => focusEntity(item),
        hidden: (item: object) => item.redacted || item.is_focused || !hasCapability("service:ticket.action.focus"),
      },
      {
        key: "unfocus",
        label: t("unfocus_entity"),
        handler: (item: object) => unfocusEntity(item),
        hidden: (item: object) => item.redacted || !item.is_focused || !hasCapability("service:ticket.action.focus"),
      },
    ];
  };

  const getBadgeStyle = (status: string) => {
    switch (status) {
      case "solved":
        return { strong: false, variant: BadgeVariant.Default };
      case "rejected":
        return { strong: true, variant: BadgeVariant.Danger };
      case "claimed":
        return { strong: true, variant: BadgeVariant.Success };
      case "created":
        return { strong: true, variant: BadgeVariant.Info };
      case "pending":
      case "ready_for_investigation":
        return { strong: true, variant: BadgeVariant.Orange };
      case "awaiting_customer":
        return { strong: true, variant: BadgeVariant.Warning };
      default:
        return { strong: true, variant: BadgeVariant.Default };
    }
  };

  return {
    createNewTicket,
    submitTicket,
    useActions,
    getBadgeStyle,
    openNewTicket,
  };
};
